export default "__VITE_ASSET__C9HhEoqy__"